module.exports = __webpack_public_path__ + "static/media/icon-width.c71f38de.svg";